import { registerModule } from '@/app/app.store'
import Common from '../common.vue'



export default {
    path: '/',
    component: Common,
    children: [
        {
            name: 'home',
            path: 'home',
            component: () => import('./home.vue'),
            beforeEnter: (to: any, from: any, next: () => void) => {
                import('./home-service').then(({ STORE }) => {
                    if (STORE) registerModule(to, STORE)
                    next()
                })
            }
        },
        {
            name: 'channel',
            path: 'channel/:channelId',
            component: () => import('./channel/channel.vue'),
        },
        {
          name: 'categorylist',
          path: 'categorylist',
          component: () => import('./category/list.vue'),
      }
    ]
  }
